// context/index.tsx
import React, { ReactElement, useMemo } from 'react';

// Static imports instead of require.context for test compatibility
import { MiaChatV2Provider } from './MiaChatContext';
import { SocketProvider } from './SocketContext';
import { AIAvatarThemeProvider } from './ThemeContext';

const providers: React.FC<{ children: React.ReactNode }>[] = [
  MiaChatV2Provider,
  SocketProvider,
  AIAvatarThemeProvider,
];

const AppProvider: React.FC<{ children: ReactElement; }> = ({ children }) => {
  const tree = useMemo(() => {
    return providers.reduceRight<ReactElement>(
      (acc, Provider) => React.createElement(Provider, { children: acc }),
      children
      );
  }, [children]); // you can include `providers` in deps if it ever changes

  return tree;
};

export default AppProvider;